import { cn } from '@repo/ui/utils'
import { motion } from 'motion/react'
import { ReactNode } from 'react'

export type PanelStatus = 'floating' | 'fixed' | 'hidden'

export function Panel({
  children,
  className,
  isOpen,
  offset,
  setIsOpen,
  width,
}: {
  children: ReactNode
  className?: string
  isOpen: boolean
  offset: number
  setIsOpen: (isOpen: boolean) => void
  width: number
}) {
  return (
    <motion.aside
      onHoverStart={() => setIsOpen(true)}
      onHoverEnd={() => setIsOpen(false)}
      transition={{ type: 'keyframes', duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
      initial={{ x: 0 }}
      animate={{ x: isOpen ? 0 : offset }}
      className={cn(
        'absolute bottom-4 top-4 z-10 overflow-hidden overflow-y-auto',
        className,
      )}
      style={{
        width: `${width}px`,
        maxWidth: `${width}px`,
      }}
    >
      {children}
    </motion.aside>
  )
}
